import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";
import { TelemetryService } from "@obg/ngx.global.evo";
import { map, tap } from "rxjs/operators";

import { LOGIN_ACTION_TYPE } from "../../login/login.action";

import { ResetPasswordEventName } from "./reset-password.model";

@Injectable()
export class ResetPasswordEffect {
	resetPasswordWithTokenSuccess$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(LOGIN_ACTION_TYPE.resetPasswordWithTokenSuccess),
				tap(() =>
					this.telemetryService.track({
						event: ResetPasswordEventName.ResetPasswordSuccess,
					})
				)
			),
		{ dispatch: false }
	);

	resetPasswordWithTokenFail$ = createEffect(
		() =>
			this.actions$.pipe(
				ofType(LOGIN_ACTION_TYPE.resetPasswordWithTokenFail),
				map((x: ActionWithPayload<AppError>) => x.payload),
				tap((error) =>
					this.telemetryService.track({
						event: ResetPasswordEventName.ResetPasswordFailed,
						Error: error.code,
					})
				)
			),
		{ dispatch: false }
	);

	constructor(
		private actions$: Actions,
		private telemetryService: TelemetryService
	) {}
}
